import { render, staticRenderFns } from "./todoHandler.vue?vue&type=template&id=1c2a3d9e&scoped=true"
import script from "./todoHandler.vue?vue&type=script&lang=js"
export * from "./todoHandler.vue?vue&type=script&lang=js"
import style0 from "./todoHandler.vue?vue&type=style&index=0&id=1c2a3d9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2a3d9e",
  null
  
)

export default component.exports